"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPANY_CREATE_TALENT_EMPLOYEE = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
const question_groups_1 = require("../../groups/question-groups");
const form_1 = require("../../utils/form");
exports.COMPANY_CREATE_TALENT_EMPLOYEE = (0, form_1.form)({
    name: "COMPANY_CREATE_TALENT_EMPLOYEE",
    title: "Create Talent for Employee",
    content: [
        question_groups_1.QuestionGroup["COMPANY_CREATE_TALENT_EMPLOYEE"], // Done
    ],
});
